import api from './api'

/**
 * 获取圈子动态
 * @export
 * @param {Object} params
 * @param {number} [params.limit]
 * @param {string} [params.action] (new: 最新|hot: 最热)
 * @param {string} [params.id] (圈子ID)
 * @returns
 */
export function getTopicFeeds (params) {
  return api.get(`/feeds/theTopic/${params.id}?type=${params.action}`, {
    validateStatus: s => s === 200,
  })
}
/**
 * 获取圈子详情
 * @export
 * @param {Object} params
 * @param {string} [params.id] (圈子ID)
 * @returns
 */
export function getTopicInfo (params) {
    return api.get(`/feed/topics/${params.id}`, {
        validateStatus: s => s === 200,
    })
}
/**
 * 获取话题动态
 * @export
 * @param {Object} params
 * @param {number} [params.limit]
 * @param {string} [params.action] (new: 最新|hot: 最热)
 * @param {string} [params.id] (话题ID)
 * @returns
 */
export function getThemeFeeds (params) {
    return api.get(`/feed-themes/${params.id}/new-feeds?type=${params.action}`, {
        validateStatus: s => s === 200,
    })
}
/**
 * 获取话题详情
 * @export
 * @param {Object} params
 * @param {string} [params.id] (话题ID)
 * @returns
 */
export function getThemeInfo (params) {
    return api.get(`/feed-themes/${params.id}`, {
        validateStatus: s => s === 200,
    })
}
